import { render, staticRenderFns } from "./RightHelpList.vue?vue&type=template&id=3bb8cd8f&scoped=true"
import script from "./RightHelpList.vue?vue&type=script&lang=js"
export * from "./RightHelpList.vue?vue&type=script&lang=js"
import style0 from "./RightHelpList.vue?vue&type=style&index=0&id=3bb8cd8f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb8cd8f",
  null
  
)

export default component.exports